
export default {
  props: {
    totalOffers: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      selectedValue: `desc`,
    };
  },
  watch: {
    selectedValue () {
      return this.$refs[`boa-select`].selectedOptions[0].value;
    },
  },
  methods: {
    pushSelectToParent () {
      return this.$emit(`selectedSort`, this.selectedValue);
    },
  },
};
